/**
 * "ResizeObserver loop ..." is a benign browser notice (the observation is
 * rescheduled to the next frame) that AG Grid triggers on resize. It is not an
 * application error, but the CRA dev-server overlay renders it as a fatal one.
 */
const RESIZE_OBSERVER_MESSAGES = [
  "ResizeObserver loop limit exceeded",
  "ResizeObserver loop completed with undelivered notifications",
];

const isResizeObserverMessage = (message) =>
  typeof message === "string" &&
  RESIZE_OBSERVER_MESSAGES.some((known) => message.includes(known));

const removeDevServerOverlay = () => {
  document.getElementById("webpack-dev-server-client-overlay")?.remove();
};

window.addEventListener(
  "error",
  (event) => {
    if (!isResizeObserverMessage(event.message)) return;

    event.stopImmediatePropagation();
    event.preventDefault();

    if (process.env.NODE_ENV === "development") {
      // The overlay is rendered asynchronously, so clear it on the next tick.
      setTimeout(removeDevServerOverlay);
    }
  },
  true
);
